const isPoLinesCompleted = (vendorType, orderLines) => {
  if (vendorType.toLowerCase() === 'warehouse') {
    const seaFreightLines = orderLines.filter((line) => line.vpFreightType === 'SeaRailAir');
    if (seaFreightLines.length === 0) {
      return true;
    }
    return seaFreightLines.every((line) => {
      return line.quantity === line.seaFreightConfirmedQty;
    });
  }
  return true;
};

export const isPOEligibleToPost = (
  vendorType,
  currentOrder,
  orderLines,
  requireApprovalLines,
  notApprovedLines
) => {
  if (vendorType.toLowerCase() !== 'warehouse') {
    return false;
  }
  if (currentOrder && Object.keys(currentOrder).length) {
    if (currentOrder.scheduledForPosting) {
      return false;
    }
    if (requireApprovalLines.length > 0) {
      return false;
    }
    if (notApprovedLines.length > 0) {
      return false;
    }
    if (currentOrder.status !== 'Released') {
      return false;
    }
    if (currentOrder.vpFreightType === 'SeaRailAir') {
      return false;
    }
    if (!isPoLinesCompleted(vendorType, orderLines)) {
      return false;
    }
    return true;
  }
  return false;
};
